import {isEmptyOrNull, isNotEmptyOrNull} from "./NamaCommon";

export function subtractTwoLists(firstList, secondList) {
    let subtractedList = [];
    if (!firstList || firstList.length === 0)
        return subtractedList;
    if (!secondList || secondList.length === 0) {
        subtractedList.push(...firstList);
        return subtractedList;
    }

    for (let firstObj of firstList) {
        let found = false;
        for (let secondObj of secondList) {
            if (firstObj === secondObj) {
                found = true;
                break;
            }
        }
        if (!found)
            subtractedList.push(firstObj);

    }
    return subtractedList;
}

export function join(...lists) {
    let joined = [];
    for (let list of lists) {
        if (isNotEmptyOrNull(list))
            joined.push(...list);
    }
    return joined;
}

export function removeAllFromList(srcList, listToRemove) {
    for (let item of listToRemove) {
        removeObjectFromList(srcList, item);
    }
}

export function removeObjectFromList(list, object) {
    var index = list.indexOf(object);
    if (index > -1) {
        list.splice(index, 1);
    }
}

export function fillWithLastElement(list, newSize) {
    while (list.length < newSize)
    {
        list.push(list[list.length-1])
    }
}

export function getOrAdd(key,map)
{
    let list = map.get(key);
    if (isEmptyOrNull(list))
        map.set(key, list = []);
    return list;
}